import { CustomEventName } from '@/constants';
import { pushEvent, resetGTMDataLayer } from '..';

export const gtmFormSubmission = (formLabel: string | undefined): void => {
  resetGTMDataLayer();
  const details = { formLabel };
  pushEvent(CustomEventName.CustomFormSubmission, details);
};

// biome-ignore lint/suspicious/noExplicitAny: GTM data layer payload is untyped
export const gtmContactFormSubmission = (data: any): void => {
  resetGTMDataLayer();
  pushEvent(CustomEventName.ContactFormSubmission, data);
};
